window.elementToTarget = null;

const adaCloseModalTarget = () => {
  if (elementToTarget != null) {
    elementToTarget.focus();
  }
}

const adaElementFiredModal = (elementFired) => {
  elementToTarget = elementFired;
}

export {
    adaCloseModalTarget,
    adaElementFiredModal
}
